var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNothingHere = function SvgNothingHere(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 140,
    viewBox: "0 0 320 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_417_1235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7923 77.9063C48.6719 77.0545 47.8695 76.4867 47.027 76.6084C46.1844 76.7301 45.6227 77.5413 45.7431 78.393C45.9437 79.8532 46.2245 84.3552 44.6999 86.1804C44.379 86.586 43.9778 86.8294 43.4562 86.9105L43.6167 78.2713C43.6568 77.014 42.6538 76 41.41 76C40.1663 76 39.1632 77.0545 39.2033 78.3119L39.6046 94.6979C39.083 94.6168 38.6416 94.3734 38.3207 93.9678C36.756 92.1427 37.0368 87.6 37.2775 86.1804C37.3979 85.3287 36.8362 84.5175 35.9936 84.3958C35.1511 84.2741 34.3888 84.842 34.2283 85.6937C34.108 86.4238 33.2253 92.7511 35.9936 95.9958C36.9566 97.1315 38.2003 97.7399 39.7249 97.8615L39.8854 105H43.2556L43.4963 90.1147C44.9407 89.993 46.2245 89.3846 47.1473 88.2895C49.7552 84.9636 48.8725 78.5958 48.7923 77.9063Z",
    fill: "#DADFE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.5 133.5C329.5 139.799 324.926 145.917 316.365 151.572C307.824 157.214 295.432 162.315 280.074 166.606C249.365 175.186 206.912 180.5 160 180.5C113.088 180.5 70.6353 175.186 39.9264 166.606C24.5685 162.315 12.1762 157.214 3.63504 151.572C-4.92585 145.917 -9.5 139.799 -9.5 133.5C-9.5 127.201 -4.92585 121.083 3.63504 115.428C12.1762 109.786 24.5685 104.685 39.9264 100.394C70.6353 91.8136 113.088 86.5 160 86.5C206.912 86.5 249.365 91.8136 280.074 100.394C295.432 104.685 307.824 109.786 316.365 115.428C324.926 121.083 329.5 127.201 329.5 133.5Z",
    fill: "url(#paint0_linear_417_1235)",
    stroke: "#ECEFF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.616 62.933C280.413 61.6071 279.152 60.7232 277.81 60.9241C276.468 61.125 275.573 62.3705 275.776 63.6964C276.142 65.9464 276.59 72.9777 274.109 75.8304C273.58 76.433 272.929 76.7946 272.116 76.9554L272.36 63.5357C272.4 61.567 270.814 60 268.821 60C266.828 60 265.242 61.6071 265.282 63.5759L265.933 89.0491C265.079 88.9286 264.428 88.5268 263.859 87.9241C261.378 85.0714 261.825 78.0402 262.191 75.7902C262.395 74.4643 261.5 73.2187 260.158 73.0179C258.815 72.817 257.554 73.7009 257.351 75.0268C257.188 76.1518 255.765 85.9955 260.117 91.058C261.622 92.7857 263.655 93.7902 266.015 93.9107L266.299 105H271.709L272.116 81.8571C274.434 81.6964 276.427 80.692 277.891 79.0045C282.243 73.942 280.82 64.058 280.616 62.933Z",
    fill: "#DADFE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.966 44.0534L162.157 41.7823C161.286 39.2934 158.921 37.6445 156.277 37.6445H129.584C126.161 37.6445 123.361 40.4445 123.361 43.8668V96.4445C123.361 99.8667 126.161 102.667 129.584 102.667H203.628C207.05 102.667 209.85 99.8667 209.85 96.4445V54.4134C209.85 50.9912 207.05 48.1912 203.628 48.1912H168.846C166.201 48.1912 163.868 46.5423 162.966 44.0534Z",
    fill: "#ECEFF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.85 95.387V96.4136C209.85 99.8359 207.05 102.636 203.628 102.636H128.588C125.135 102.636 121.775 100.147 121.059 97.0359L110.046 49.747C109.33 46.6359 111.539 44.147 114.961 44.147H141.655C144.299 44.147 147.006 45.6403 148.406 47.8803L149.681 49.9336C151.081 52.1736 153.788 53.667 156.401 53.667H191.215C194.637 53.667 198.028 56.187 198.744 59.267L207.237 95.7603C207.424 96.4759 208.17 96.8803 208.855 96.6936C209.477 96.5381 209.85 96.0092 209.85 95.387Z",
    fill: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 67,
    width: 4,
    height: 20,
    rx: 2,
    fill: "#E3E7ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 75,
    width: 4,
    height: 20,
    rx: 2,
    transform: "rotate(90 170 75)",
    fill: "#DADFE8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_417_1235",
    x1: 160.006,
    y1: 64.456,
    x2: 160.006,
    y2: 139.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECEFF3",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4764,
    stopColor: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_417_1235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 140,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNothingHere);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "nothing_here.982cf8d1fca3e40f69e86aa93816f430.svg";